const quickLinks = [
  { label: '本季新番速览', href: '#season' },
  { label: '新番推荐', href: '#recommend' },
  { label: '资源合集', href: '#collections' },
  { label: '追番时间表', href: '#schedule' },
  { label: '频道分类', href: '#genres' },
  { label: '热度排行榜', href: '#ranking' },
  { label: '常见问题', href: '#faq' },
];

const keywords = ['妖精动漫在线', '新番推荐', '无修资源索引', '里番合集', '追番时间表', '补番清单'];

export default function Footer() {
  return (
    <footer className="w-full bg-background-200 border-t border-background-300">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-1">
            <a href="#top" className="inline-flex items-center gap-2 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
                <i className="ri-sparkling-2-fill"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">妖精动漫</span>
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-sm">
              一个把新番推荐、资源索引与追番安排整理在一起的浏览页面，帮助你在开始观看前先理清想看什么、按什么顺序看。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">
              <a href="#recommend" className="cursor-pointer hover:text-primary-600">页面导航</a>
            </h4>
            <ul className="grid grid-cols-2 gap-y-2.5 gap-x-4">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-foreground-600 hover:text-primary-600 whitespace-nowrap cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">
              <a href="#collections" className="cursor-pointer hover:text-primary-600">内容关键词</a>
            </h4>
            <div className="flex flex-wrap gap-2">
              {keywords.map((k) => (
                <span key={k} className="rounded-full bg-background-50 border border-background-300 px-3 py-1 text-xs text-foreground-600">
                  {k}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs md:text-sm text-foreground-500">本页内容为示例性整理，仅用于浏览与筛选演示。</p>
          <p className="text-xs md:text-sm text-foreground-500">妖精动漫 · 在线看番浏览页</p>
        </div>
      </div>
    </footer>
  );
}